import { Component } from "react";
import { INavigationParcours, obtenirNavigationUrl } from "../../util/Navigation";
import * as CONFIG_GABARIT_GLOBAL from "../../GabaritGlobalConfig";
import { getMetaTagContent } from "../../scripts/getMetaTag";
import { loadNavigationScripts } from "../../scripts/loadNavigationScripts";
import "./Content.css";
import ServiceAssurabiliteBFF from "../utils/ServiceAssurabiliteBFF";
import { InformationsPreAssurabilite } from "../../models/informations-pre-assurabilite";
import TexteHautQuestionnaire from "../AMC/TexteHautQuestionnaire";
import i18n from "../../resources/I18n";
import Questionnaire from "./Questionnaire";
import ModalLoadingAMC from "./ModalLoadingAMC";
import SpanAlerte from "../APRHN/SpanAlerte";
import Boutons from "./Boutons";
import ClickToCall from "./ClickToCall";
import * as TYPE_PARCOURS from "../../constants/typeParcours";
import QuestionsSommaireErreurs from "./QuestionsSommaireErreurs";
import { QuestionnaireContext } from "../utils/QuestionnaireContext";
import StepIndicator from "./StepIndicator";
import { withNavigation } from "./withNavigation";
import { CybermetrieAMCContext } from "../utils/CybermetrieAMCContext";
import { CybermetriesAMC } from "../../util/CybermetrieAMC";

interface IContentProps {
  parcours: string;
  cookieParcoursAssurance: INavigationParcours;
}

interface IWithNavigationProps {
  navigate: (path: string) => void;
}

interface IContentState {
  informationsPreAssurabilite: InformationsPreAssurabilite;
  isApp: boolean;
  estEmprunteurPrimaire?: boolean;
  estPreneurAssurance?: boolean;
  redirigerVersErreur: boolean;
  enChargement: boolean;
  stateQuestionnaireSoumis: boolean;
  questionStepCourant: number;
  enChargementQuestion: boolean;
  erreurStatut: number;
  showBtnContinuer: boolean;
  modaleEnregistrerOuvert: boolean;
  declencheurModaleEnregistrer: string;
  modaleAnnulerOuvert: boolean;
  declencheurModaleAnnuler: string;
  modaleDonnerControleOuvert: boolean;
  declencheurModaleDonnerControle: string;
  obtenirReponse: boolean;
}

class Content extends Component<IContentProps & IWithNavigationProps, IContentState> {
  ServiceAssurabiliteBFF: ServiceAssurabiliteBFF;

  constructor(props: any) {
    super(props);
    this.state = {
      informationsPreAssurabilite: {},
      isApp: false,
      redirigerVersErreur: false,
      enChargement: false,
      stateQuestionnaireSoumis: false,
      questionStepCourant: 0,
      enChargementQuestion: false,
      erreurStatut: 0,
      showBtnContinuer: false,
      modaleEnregistrerOuvert: false,
      declencheurModaleEnregistrer: "",
      modaleAnnulerOuvert: false,
      declencheurModaleAnnuler: "",
      modaleDonnerControleOuvert: false,
      declencheurModaleDonnerControle: "",
      obtenirReponse: false,
    };

    this.ServiceAssurabiliteBFF = new ServiceAssurabiliteBFF();
    this.handleReponseQuestion = this.handleReponseQuestion.bind(this);
    this.onClickEtatModaleEnregistrer = this.onClickEtatModaleEnregistrer.bind(this);
    this.onClickEtatModaleAnnuler = this.onClickEtatModaleAnnuler.bind(this);
    this.onClickEtatModaleDonnerControle = this.onClickEtatModaleDonnerControle.bind(this);
    this.onClickObtenirReponse = this.onClickObtenirReponse.bind(this);
  }

  async componentDidMount() {
    let cookieParcoursAssurance = this.props.cookieParcoursAssurance;

    if (!cookieParcoursAssurance) {
      // Page erreur
    } else if (!cookieParcoursAssurance.idSouscription || !cookieParcoursAssurance.idAssure) {
      // Page erreur
    } else {
      this.setState({ enChargement: true });
      await this.ServiceAssurabiliteBFF.effectuerAppelPostDemarrerPreAssurabilite(
        cookieParcoursAssurance.idSouscription,
        cookieParcoursAssurance.idAssure,
        cookieParcoursAssurance.langue,
        this.succesAppelPostDemarrerPreAssurabilite,
        this.erreurAppelBFF,
        cookieParcoursAssurance.idCallback
      );
    }

    this.setState({ isApp: getMetaTagContent("oel-is-app") !== null ? getMetaTagContent("oel-is-app") : false });
    loadNavigationScripts("AMC");
  }

  succesAppelPostDemarrerPreAssurabilite = (reponse: { data: InformationsPreAssurabilite }) => {
    const { cookieParcoursAssurance } = this.props;
    const assures = reponse.data.assures || [];
    const assure = assures.find((a: any) => a.id === cookieParcoursAssurance.idAssure);
    this.setState(
      {
        informationsPreAssurabilite: reponse.data,
        enChargement: false,
        estEmprunteurPrimaire: assure ? assure.indicateurEmprunteurPrimaire : undefined,
        estPreneurAssurance: assure ? assure.estPreneurAssurance : undefined,
        redirigerVersErreur: !assure,
      },
      () => {
        this.chargerTitrePage();
        CybermetriesAMC.EnvoiePageQuestionnaireAMC(this.creeCybermetrieParams(this.state.informationsPreAssurabilite));
      }
    );
  };

  erreurAppelBFF = (reponse: any) => {
    this.setState({ redirigerVersErreur: true, enChargement: false });
  };

  async handleReponseQuestion(idQuestion: string, reponseQuestion: string) {
    this.setState({ obtenirReponse: false });
    let informationsPreAssurabilite: InformationsPreAssurabilite = { ...this.state.informationsPreAssurabilite };
    let question = informationsPreAssurabilite.questions?.find((question) => question.id === idQuestion);

    if (question.reponse !== reponseQuestion) {
      question.reponse = reponseQuestion;
      this.setState({
        informationsPreAssurabilite: informationsPreAssurabilite,
        stateQuestionnaireSoumis: false,
        questionStepCourant: question.step,
        enChargementQuestion: true,
      });

      await this.ServiceAssurabiliteBFF.effectuerAppelPostRepondreQuestionPreassurabilite(
        informationsPreAssurabilite.idAssurabilite,
        question.id,
        question.step,
        question.reponse,
        this.succesAppelPostRepondrePreAssurabilite,
        this.erreurAppelBFF
      );
    }
  }

  succesAppelPostRepondrePreAssurabilite = (reponse: { data: InformationsPreAssurabilite }) => {
    this.setState((prevState) => {
      let informationsPreAssurabilite: InformationsPreAssurabilite = { ...prevState.informationsPreAssurabilite };
      informationsPreAssurabilite.decision = reponse.data.decision;
      informationsPreAssurabilite.exigence = reponse.data.exigence;
      const stepQuestionRepondu: number = prevState.questionStepCourant;

      //Retirer les questions dont le step est supérieur à la question que l'utilisateur vient de répondre
      for (let i = informationsPreAssurabilite.questions.length - 1; i >= 0; i--) {
        if (informationsPreAssurabilite.questions[i].step > stepQuestionRepondu) {
          informationsPreAssurabilite.questions.pop();
        }
      }

      informationsPreAssurabilite.questions = [...informationsPreAssurabilite.questions, ...reponse.data.questions];

      const shouldShow = !!(informationsPreAssurabilite.exigence || informationsPreAssurabilite.decision);
      return {
        informationsPreAssurabilite: informationsPreAssurabilite,
        enChargement: false,
        erreurStatut: 0,
        enChargementQuestion: false,
        showBtnContinuer: shouldShow,
      };
    });
  };

  onClickContinuer = () => {
    this.setState({ stateQuestionnaireSoumis: true });

    const { parcours, cookieParcoursAssurance, navigate } = this.props;

    if (this.state.estEmprunteurPrimaire) {
      const url = obtenirNavigationUrl(cookieParcoursAssurance.idCallback);
      const urlParams = `${parcours}/${cookieParcoursAssurance.langue}/next?idSouscription=${cookieParcoursAssurance.idSouscription}&idAssure=${cookieParcoursAssurance.idAssure}&isApp=${this.state.isApp}`;
      window.location.assign(url + urlParams);
    } else {
      navigate(
        `/amc/validation/${parcours}/?idSouscription=${cookieParcoursAssurance.idSouscription}&idAssure=${cookieParcoursAssurance.idAssure}&langue=${cookieParcoursAssurance.langue}&idCallback=${cookieParcoursAssurance.idCallback}&isApp=${this.state.isApp}`
      );
    }
  };

  chargerTitrePage = () => {
    const isApp = getMetaTagContent("oel-is-app") === "true";
    const estNouvelleMarge = this.state.informationsPreAssurabilite.estNouvelleMarge;

    let titre = "";
    if (isApp) {
      titre = estNouvelleMarge
        ? i18n.t("amc:titre-webview-nouvelle-marge")
        : i18n.t("amc:titre-webview-non-nouvelle-marge");
    } else {
      titre = estNouvelleMarge ? i18n.t("amc:titre-web-nouvelle-marge") : i18n.t("amc:titre-web-non-nouvelle-marge");
    }
    document.title = titre;
  };

  handleCloseModale(declencheur: string, btnId: string) {
    let elementRetour: HTMLElement | null = null;
    if (declencheur === "btn-evenement-retour") {
      elementRetour = document
        .getElementsByTagName("oel-header-transactionnel")[0]
        .shadowRoot.getElementById("btn-evenement-retour");
    } else {
      elementRetour = document.getElementById(btnId)?.getElementsByClassName("button")[0] as HTMLElement;
    }

    setTimeout(() => {
      document.getElementById(btnId)?.querySelector("button")?.removeAttribute("tabIndex");
      document.getElementsByTagName("oel-header-transactionnel")[0]?.removeAttribute("tabIndex");
      elementRetour?.focus();
    }, 1);
  }

  onClickEtatModaleEnregistrer(etat: boolean, declencheur: string) {
    this.setState({ modaleEnregistrerOuvert: etat });
    if (etat) {
      this.setState({ declencheurModaleEnregistrer: declencheur });
    } else {
      const trigger = declencheur || this.state.declencheurModaleEnregistrer;
      this.handleCloseModale(trigger, "btn-enregistrer-amc");
    }
  }

  onClickEtatModaleAnnuler(etat: boolean, declencheur: string) {
    this.setState({ modaleAnnulerOuvert: etat });
    if (etat) {
      this.setState({ declencheurModaleAnnuler: declencheur });
    } else {
      const trigger = declencheur || this.state.declencheurModaleAnnuler;
      this.handleCloseModale(trigger, "btn-annuler-amc");
    }
  }

  onClickEtatModaleDonnerControle(etat: boolean, declencheur: string) {
    this.setState({ modaleDonnerControleOuvert: etat });
    if (etat) {
      this.setState({ declencheurModaleDonnerControle: declencheur });
    } else {
      const trigger = declencheur || this.state.declencheurModaleDonnerControle;
      this.handleCloseModale(trigger, "btn-donner-controle-amc");
    }
  }

  creeCybermetrieParams(informationsPreassurabilite: InformationsPreAssurabilite) {
    const { idAssure } = this.props.cookieParcoursAssurance;
    const assures = informationsPreassurabilite.assures || [];
    const assure = assures.find((a: any) => a.id === idAssure);
    return {
      estEmprunteurUnique: assures.length === 1,
      estEmprunteurPrimaire: assure?.indicateurEmprunteurPrimaire === true,
      estNouvelleMarge: informationsPreassurabilite.estNouvelleMarge,
      parcours: this.props.parcours,
      noDemande: informationsPreassurabilite.noDemande,
    };
  }

  questionsToutesRepondues() {
    const questionsSansReponse = this.state.informationsPreAssurabilite.questions?.filter(
      (question) => question.reponse == null
    );
    return questionsSansReponse?.length === 0;
  }

  onClickObtenirReponse() {
    this.setState({ obtenirReponse: true });
    CybermetriesAMC.EnvoieObtenirReponseAMC(this.creeCybermetrieParams(this.state.informationsPreAssurabilite));
  }

  afficherBtnObtenirReponse() {
    return !(this.state.obtenirReponse && this.questionsToutesRepondues());
  }

  render() {
    if (this.state.redirigerVersErreur) {
      const url = `${obtenirNavigationUrl(this.props.cookieParcoursAssurance.idCallback)}${this.props.parcours}/${
        this.props.cookieParcoursAssurance.langue
      }/error?idSouscription=${this.props.cookieParcoursAssurance.idSouscription}&idAssure=${
        this.props.cookieParcoursAssurance.idAssure
      }`;
      window.location.replace(url);
      return null;
    }
    return (
      <gabarit-global configuration={CONFIG_GABARIT_GLOBAL.config}>
        <div id="contenu-principal-amc" tabIndex={-1}>
          <main className="dsd-custom-grid">
            {this.state.enChargementQuestion && <ModalLoadingAMC />}
            {!this.state.enChargementQuestion && <SpanAlerte>{i18n.t("sr-only-chargement-termine")}</SpanAlerte>}
            <CybermetrieAMCContext.Provider value={this.creeCybermetrieParams(this.state.informationsPreAssurabilite)}>
              <dsd-grid class="dsd-fg-1 dsd-d-flex dsd-fd-col">
                <dsd-grid-row class="md:dsd-fg-1">
                  <dsd-grid-col
                    col="12"
                    md-col="4"
                    lg-col="3"
                    class="md:dsd-fg-1 md:dsd-d-flex dsd-custom-grid-left-column"
                  >
                    <div className="dsd-d-flex dsd-fg-1 dsd-p-md dsd-pt-sm dsd-pb-sm dsd-w-100">
                      {this.state.informationsPreAssurabilite.estNouvelleMarge !== undefined &&                       
                      <StepIndicator
                        estEmprunteurPrimaire={this.state.estEmprunteurPrimaire}
                        estNouvelleMarge={this.state.informationsPreAssurabilite.estNouvelleMarge}
                        estPreneurAssurance={this.state.estPreneurAssurance}
                      />}
                    </div>
                  </dsd-grid-col>
                  <dsd-grid-col col="12" md-col="8" lg-col="9" class="md:dsd-fg-1">
                    <div className="amc-contenu">
                      <div className="">
                        <TexteHautQuestionnaire
                          estPlusieursAssures={this.state.informationsPreAssurabilite.assures?.length > 1}
                        />
                        {this.state.obtenirReponse && !this.questionsToutesRepondues() && (
                          <QuestionsSommaireErreurs
                            parcours={this.props.parcours}
                            questions={this.state.informationsPreAssurabilite.questions}
                          />
                        )}
                        <QuestionnaireContext.Provider value={{ estSoumis: this.state.obtenirReponse }}>
                          <div className="questionnaire">
                            <Questionnaire
                              parcours={this.props.parcours}
                              informationsPreAssurabilite={this.state.informationsPreAssurabilite}
                              enChargement={this.state.enChargement}
                              handleReponseQuestion={this.handleReponseQuestion}
                              idAssure={this.props.cookieParcoursAssurance.idAssure}
                              onClickObtenirReponse={this.onClickObtenirReponse}
                              showVerdict={this.state.obtenirReponse}
                              estNouvelleMarge={this.state.informationsPreAssurabilite.estNouvelleMarge}
                              showBtnObtenirReponse={this.afficherBtnObtenirReponse()}
                            />
                            <Boutons
                              onClickContinuer={this.onClickContinuer}
                              onClickEtatModaleEnregistrer={this.onClickEtatModaleEnregistrer}
                              onClickEtatModaleAnnuler={this.onClickEtatModaleAnnuler}
                              onClickEtatModaleDonnerControle={this.onClickEtatModaleDonnerControle}
                              modaleEnregistrerOuvert={this.state.modaleEnregistrerOuvert}
                              modaleAnnulerOuvert={this.state.modaleAnnulerOuvert}
                              modaleDonnerControleOuvert={this.state.modaleDonnerControleOuvert}
                              cookieParcoursAssurance={this.props.cookieParcoursAssurance}
                              showBtnContinuer={this.state.showBtnContinuer}
                              informationsPreAssurabilite={this.state.informationsPreAssurabilite}
                              parcours={this.props.parcours}
                              estNouvelleMarge={this.state.informationsPreAssurabilite.estNouvelleMarge}
                              estEmprunteurPrimaire={this.state.estEmprunteurPrimaire}
                              showVerdict={this.state.obtenirReponse}
                            />
                          </div>
                        </QuestionnaireContext.Provider>
                        {this.props.parcours === TYPE_PARCOURS.AUTONOME ? (
                          <ClickToCall
                            id={"click-to-call-amc"}
                            transit={this.state.informationsPreAssurabilite.transit}
                            noDemande={this.state.informationsPreAssurabilite.noDemande}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </dsd-grid-col>
                </dsd-grid-row>
              </dsd-grid>
            </CybermetrieAMCContext.Provider>
          </main>
        </div>
      </gabarit-global>
    );
  }
}

export default withNavigation(Content);
